import React, { useState } from 'react'

import { NavigationTabs, TournamentsList } from './components'
import useHost from '../../hooks/useHost'
import { HOSTS } from '../../constants'

import { MENU_TABS } from './constants'
import styles from './styles.module.scss'

const Calendar = () => {
  const [activeTab, setActiveTab] = useState()
  const isM87PassportGg =
    useHost(HOSTS.m87PassportGg) || useHost(HOSTS.m87DevPassportGg)

  if (isM87PassportGg) {
    return <TournamentsList />
  }

  return (
    <div className={styles.calendarWrapper} data-testid='calendar-page'>
      <div>
        <NavigationTabs onChangeActiveTab={id => setActiveTab(id)} />

        {MENU_TABS?.map(
          tab =>
            tab?.id === activeTab && (
              <div key={tab?.id} data-testid={`tab-content-${tab.id}`}>
                {tab.components()}
              </div>
            )
        )}
      </div>
    </div>
  )
}

export default Calendar
